import { POSITION, TYPE } from "vue-toastification";
import type { PluginOptions } from "vue-toastification";
import { EdroneToastOptions, ExternalApiToastTypes, VueToastificationTypes } from "./types";

export { defaultPluginOptions, makeVueToastificationOptions, defaultToastType, toastTypes };

const defaultPluginOptions: PluginOptions = {
  timeout: 5000,
  closeOnClick: false,
  closeButton: false,
  icon: false,
  hideProgressBar: true,
  pauseOnFocusLoss: false,
  draggable: false,
  toastClassName: "edrone-toast",
  containerClassName: "edrone-toast-container",
  position: POSITION.TOP_RIGHT,
  transition: {
    enter: "edrone-toast-fade-enter-active",
    leave: "edrone-toast-fade-leave-active",
    move: "edrone-toast-fade-move",
  },
};

type ReturnMakeVueToastificationOptions = {
  vueToastificationType: VueToastificationTypes;
  vueToastificationOptions: EdroneToastOptions & { type: undefined };
};

function makeVueToastificationOptions(options?: EdroneToastOptions): ReturnMakeVueToastificationOptions {
  const toastType = getVueToastificationType(options?.type);
  return {
    vueToastificationType: toastType,
    vueToastificationOptions: {
      ...options, //this should be second because user's options overrides default toast options
      type: undefined, //because we are calling vueToastification[toastType] instead (update: we use our own component and pass type as prop to it)
    },
  };
}

const defaultToastType = TYPE.DEFAULT;

const toastTypes: ExternalApiToastTypes = {
  error: TYPE.ERROR,
  success: TYPE.SUCCESS,
  warn: TYPE.WARNING,
  inbox: TYPE.INFO,
  info: TYPE.DEFAULT,
};

function getVueToastificationType(type?: EdroneToastOptions["type"]): VueToastificationTypes {
  if (!type) {
    return TYPE.DEFAULT;
  }

  return toastTypes[type];
}
